import type { IRoiCalculatorResults } from './types';
import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';
import Button from '@klv/atoms/button';
import * as styles from './styles/roiResults.module.scss';

const RoiResults = ({ calculatedRoi,
}: IRoiCalculatorResults) => {
  const { t } = useTranslation();

  const invalidRoi = Number(calculatedRoi?.total || 0) < 0 || parseInt(`${(calculatedRoi?.total || '0')}`.replace(/,/g, ''), 10) > 9999 || calculatedRoi?.total === 'Infinity';
  const freeTier = calculatedRoi?.activeProfiles === 0 || Number(calculatedRoi?.activeProfiles || 251) <= 250;
  let bottomText = t('roiCalculator_results_signupText');
  if (invalidRoi) {
    bottomText = t('roiCalculator_results_invalidRoi');
  } else if (freeTier) {
    bottomText = t('roiCalculator_results_freeTier');
  }

  return (
      <div className={styles.roiResultsContainer}>
          <h5 className={generateClassName(['h5', styles.headlineText])}>{t('roiCalculator_results_headlineText')}</h5>
          <h2 className={generateClassName(['h2', styles.revenueTotal])}>{invalidRoi || freeTier ? '-' : `${calculatedRoi?.total || ''}x`}</h2>
          <h3 className={generateClassName(['h2', styles.revenuePerYear])}>{t('roiCalculator_results_revenuePerYear')}</h3>
          {!invalidRoi && !freeTier && (
            <>
              <hr className={styles.horizontalLine}/>
              <h5 className={generateClassName(['h5', styles.headlineText, styles.leftAligned])}>{t('roiCalculator_results_subHeadlineText')}</h5>
              <table className={styles.table}>
                <tbody>
                  <tr>
                    <td>{t('roiCalculator_results_newSubscribers')}</td>
                    <td className={styles.revenueAmount}>{calculatedRoi?.subscriberRevenue || '$ -'}</td>
                  </tr>
                  <tr>
                    <td>{t('roiCalculator_results_campaigns')}</td>
                    <td className={styles.revenueAmount}>{calculatedRoi?.campaignsRevenue || '$ -'}</td>
                  </tr>
                  <tr>
                    <td>{t('roiCalculator_results_automatedFlows')}</td>
                    <td className={styles.revenueAmount}>{calculatedRoi?.flowsRevenue || '$ -'}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
        <hr className={styles.horizontalLine}/>
        <p className={generateClassName(['paragraph2', styles.signupText, invalidRoi || freeTier ? styles.invalidRoi : ''])}>{bottomText}</p>
        <div className={styles.buttonsContainer}>        
          {!invalidRoi && <Button className={styles.getStartedButton} text={t('roiCalculator_results_getStartedButton')} url="https://www.klaviyo.com/sign-up" variant={freeTier ? 'tertiary' : 'primary'} />}
          {!freeTier && <Button text={t('roiCalculator_results_talkToSales')} url="https://www.klaviyo.com/demo-request" variant="tertiary"/>}
        </div>
      </div>
  );
};

export default RoiResults;
